import React, { useState, useMemo, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import {
  MessagesSquare, ArrowLeft, Search, Sparkles, ChevronRight,
  // topic icons
  Coffee, Book, Music, Car, Plane, Heart, Globe, Sun, Moon, Star,
  Cat, Dog, Fish, Bird, Flower2, TreePine, Utensils, Pizza, IceCream,
  Cake, Wine, Beer, Cpu, Smartphone, Laptop, Camera, Film, Tv, Gamepad2,
  Trophy, Dumbbell, Bike, Ship, Train, Bus, Rocket, Baby, Users, Home,
  Building2, Briefcase, GraduationCap, Palette, Brush, PenTool, Church,
  DollarSign, Bitcoin, ShoppingBag, ShoppingCart, Gift, Bell, Cloud,
  CloudRain, Snowflake, Zap, Flame, Droplets, Leaf, Mountain, Waves,
  Compass, Map, MapPin, Anchor, Hash, Brain, Eye, Smile, ThumbsUp,
  Handshake, MessageCircle, Phone, Mail, Wifi, Lock, Shield, Scale,
  Stethoscope, Pill, Syringe, HeartPulse, Dna, FlaskConical, Atom,
  Sparkle, Crown, Gem, Feather, Rainbow,
} from 'lucide-react';
import { CONVERSATIONS, ALPHABET } from '../data/conversations';

// Smart keyword → icon mapping (case-insensitive substring match)
const ICON_MAP = [
  // Food & drink
  [/coffee|cafe|kaffee/i, Coffee],
  [/tea|chamomile/i, Coffee],
  [/pizza/i, Pizza],
  [/cake|dessert|cookie|croissant|brezel|bagel|donut/i, Cake],
  [/ice.?cream/i, IceCream],
  [/wine|champagne/i, Wine],
  [/beer|bier|beer-pong/i, Beer],
  [/burger|bacon|chicken|beef|meat|butcher|corn|curry/i, Utensils],
  [/food|breakfast|dinner|lunch|meal|buffet|restaurant|eat|snack|cheese|candy|chocolate|avocado|banana|cherry|cocktail|cocomelon|cola/i, Utensils],
  // Animals
  [/cat|katze/i, Cat],
  [/dog|hund/i, Dog],
  [/fish|shark|crab|dolphin/i, Fish],
  [/bird|eagle|owl/i, Bird],
  [/cow|bear|dragon|dinosaur|crocodile|animal|zoo|butterfly|horse/i, Bird],
  // Nature
  [/flower|rose|bouquet/i, Flower2],
  [/tree|forest|wood|leaf/i, TreePine],
  [/mountain|alp/i, Mountain],
  [/beach|ocean|sea|wave/i, Waves],
  [/desert|sand/i, Sun],
  [/snow|winter|ice/i, Snowflake],
  [/rain|cloud|storm/i, CloudRain],
  [/sun|summer|light/i, Sun],
  [/moon|night|dark/i, Moon],
  [/star|astro/i, Star],
  [/water|droplet/i, Droplets],
  [/fire|flame|hot/i, Flame],
  [/rainbow/i, Rainbow],
  // Tech
  [/ai|artificial|robot|cpu|computer|tech/i, Cpu],
  [/phone|smartphone|iphone|apple|android|call/i, Smartphone],
  [/laptop|browser|internet|cloud|wifi|online/i, Laptop],
  [/camera|photo|snap/i, Camera],
  [/film|movie|cinema|netflix|breaking bad|bollywood/i, Film],
  [/tv|television|ard|casting|show/i, Tv],
  [/game|gaming|xbox|playstation|bingo|board game|chess|dart|puzzle/i, Gamepad2],
  // Sport
  [/football|fussball|soccer|basketball|baseball|volleyball|cricket|boxing|dumbbell|gym|fitness|sport|running|athlete/i, Trophy],
  [/bike|cycling/i, Bike],
  [/swim|diving/i, Fish],
  // Transport
  [/car|audi|bmw|mercedes|vehicle|auto/i, Car],
  [/plane|flight|airline|airport|aviation/i, Plane],
  [/train|bahn|zug/i, Train],
  [/bus|transport/i, Bus],
  [/ship|boat|sail|anchor|marine/i, Ship],
  [/rocket|space|nasa|astronaut|alien|universe|black.?hole/i, Rocket],
  // People / Family / Emotions
  [/baby|child|kid|infant/i, Baby],
  [/family|mother|father|parent|aunt|uncle|brother|sister|daughter|son|friend|community|team|group|users|people/i, Users],
  [/love|heart|romance|dating|relationship|marriage|wedding|kiss|couple/i, Heart],
  [/happy|joy|smile|fun|laugh/i, Smile],
  [/sad|cry|tears|grief|loss/i, Droplets],
  [/anger|angry|wut|hate|fight|violence/i, Flame],
  [/anxiety|depression|adhd|autism|mental|therapy|trauma|attachment|abuse|addiction|border|dysmorphia/i, Brain],
  [/awesome|amazing|cool|great|thumbs/i, ThumbsUp],
  [/handshake|deal|agreement/i, Handshake],
  // Home & work
  [/home|house|apartment|housing|accommodation|kitchen|closet|bathroom|bedroom/i, Home],
  [/office|business|company|corporate|ceo|boss|employer|employee|work|job|career|salary|resume/i, Briefcase],
  [/building|city|urban|berlin|brooklyn|dubai|bavaria|architecture|construction/i, Building2],
  [/school|university|study|education|student|graduation|class|teacher|learn/i, GraduationCap],
  // Culture
  [/art|design|paint|draw|creative/i, Palette],
  [/music|song|singer|band|cover|album|choir|dj|dance|disco/i, Music],
  [/book|library|read|literature|novel|dictionary|comic/i, Book],
  [/church|religion|god|bible|christian|buddhist|islam|faith|jesus/i, Church],
  // Money
  [/money|dollar|euro|price|cost|salary|bankrupt|debt|coupon|billionaire|shopping|bag/i, DollarSign],
  [/bitcoin|crypto|blockchain|nft/i, Bitcoin],
  [/gift|present|birthday/i, Gift],
  [/shopping|shop|store|market|cart/i, ShoppingCart],
  // Places/Countries
  [/germany|deutschland|europe|africa|america|asia|country|nation/i, Globe],
  [/argentina|azerbaijan|albania|alaska|antarctica|belgium|brazil|canada|chile|congo|costa rica|denmark|dubai|britain|congo/i, Globe],
  [/map|compass|travel|tourism|journey|vacation/i, Compass],
  [/location|address|pin|region/i, MapPin],
  // Health & Science
  [/doctor|hospital|clinic|nurse|medic|health/i, Stethoscope],
  [/pill|medicine|drug|pharma/i, Pill],
  [/vaccine|shot|syringe|blood|donation/i, Syringe],
  [/heartbeat|pulse|cardio|cpr/i, HeartPulse],
  [/dna|gene|biology/i, Dna],
  [/chemistry|chemical|lab|experiment/i, FlaskConical],
  [/atom|physics|science|einstein/i, Atom],
  // Comms
  [/message|chat|talk|conversation|communication|complain|discuss/i, MessageCircle],
  [/email|mail/i, Mail],
  [/phone|call/i, Phone],
  // Misc symbolic
  [/celeb|famous|star|fame|billion|beckham|ronaldo|einstein|grande|d'amelio|gates|tate|chanel|mcgregor|max|ariana|bill|bonnie|bohlen|50 cent/i, Crown],
  [/beauty|makeup|braid|hair|nail|fashion|brand/i, Sparkle],
  [/gem|diamond|jewel|bracelet/i, Gem],
  [/awareness|change|challenge|achievement|goal|target|success/i, Zap],
  [/law|legal|contract|court|justice|scale|citizen/i, Scale],
  [/lock|security|privacy|safety/i, Lock],
  [/protect|shield|defence/i, Shield],
  [/eye|vision|see/i, Eye],
  [/pen|write|draw/i, PenTool],
];

const iconFor = (title) => {
  for (const [regex, Ico] of ICON_MAP) {
    if (regex.test(title)) return Ico;
  }
  return Hash;
};

const LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];
const levelOf = (title) => (title.match(/\((A1|A2|B1|B2|C1|C2)\)/) || [])[1] || null;
const LEVEL_COUNTS = LEVELS.reduce((acc, lv) => {
  acc[lv] = ALPHABET.reduce((n, l) => n + CONVERSATIONS[l].filter((t) => levelOf(t.title) === lv).length, 0);
  return acc;
}, {});

const ConversationsPage = () => {
  const [activeLetter, setActiveLetter] = useState('A');
  const [level, setLevel] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [selectedTopic]);

  const topics = CONVERSATIONS[activeLetter] || [];

  const totalReady = useMemo(
    () =>
      ALPHABET.reduce(
        (n, l) =>
          n +
          (CONVERSATIONS[l]?.filter((t) => t.questions && t.questions.length > 0).length || 0),
        0
      ),
    []
  );

  const searchResults = useMemo(() => {
    if (!search.trim() && !level) return null;
    const q = search.trim().toLowerCase();
    const out = [];
    ALPHABET.forEach((l) => {
      CONVERSATIONS[l].forEach((t) => {
        if (level && levelOf(t.title) !== level) return;
        if (!q || t.title.toLowerCase().includes(q)) out.push({ ...t, letter: l });
      });
    });
    return out;
  }, [search, level]);

  // Topic detail view
  if (selectedTopic) {
    const Icon = iconFor(selectedTopic.title);
    return (
      <div
        className="min-h-screen flex flex-col bg-gradient-to-b from-babyblue-50 via-babyblue-100/40 to-white"
        data-testid="convo-detail"
      >
        <Navbar />
        <main className="flex-1 py-12 px-6">
          <div className="container mx-auto max-w-3xl">
            <button
              onClick={() => setSelectedTopic(null)}
              className="flex items-center gap-2 text-primary hover:text-primary-hover mb-6 font-medium transition-colors"
              data-testid="back-to-topics"
            >
              <ArrowLeft className="w-5 h-5" /> Zurück / Back
            </button>

            <div className="bg-white rounded-3xl shadow-lg border border-babyblue-200 p-8 md:p-10 relative overflow-hidden">
              <div className="absolute -top-16 -right-16 w-48 h-48 bg-babyblue-100/60 rounded-full blur-2xl" />
              <div className="relative">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-babyblue-100 to-babyblue-200 flex items-center justify-center text-primary shadow-sm">
                    <Icon className="w-8 h-8" />
                  </div>
                  <div>
                    <div className="inline-flex items-center gap-2 bg-babyblue-100 text-primary px-3 py-1 rounded-full text-xs font-medium mb-2">
                      <MessagesSquare className="w-3.5 h-3.5" /> Germanatic Convo
                    </div>
                    <h1 className="font-heading text-3xl md:text-4xl font-bold text-babyblue-900 leading-tight">
                      {selectedTopic.title}
                    </h1>
                  </div>
                </div>

                {selectedTopic.questions && selectedTopic.questions.length > 0 ? (
                  <ol className="space-y-3 mt-6">
                    {selectedTopic.questions.map((q, i) => (
                      <li
                        key={i}
                        className="flex gap-4 bg-babyblue-50/60 hover:bg-babyblue-50 border border-babyblue-100 rounded-xl p-4 transition-colors"
                        data-testid={`convo-question-${i}`}
                      >
                        <span className="flex-shrink-0 w-8 h-8 rounded-full bg-white border border-babyblue-200 text-primary font-bold text-sm flex items-center justify-center">
                          {i + 1}
                        </span>
                        <span className="text-babyblue-800 leading-relaxed pt-1">{q}</span>
                      </li>
                    ))}
                  </ol>
                ) : (
                  <div className="bg-babyblue-50 border-l-4 border-primary p-5 rounded-r-xl mt-6">
                    <p className="text-babyblue-800 leading-relaxed mb-2">
                      Für dieses Thema sind bald Gesprächsfragen verfügbar. Nutze das Thema als
                      freien Kickstarter — sprich frei drauflos oder nimm dich beim Antworten auf!
                    </p>
                    <p className="text-babyblue-600 text-sm italic">
                      Conversation questions for this topic are coming soon. Use the topic as a
                      free-form kickstarter — speak freely or record yourself answering.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  // Listing view
  const displayed = searchResults ?? topics.map((t) => ({ ...t, letter: activeLetter }));

  return (
    <div
      className="min-h-screen flex flex-col bg-gradient-to-b from-babyblue-50 via-babyblue-100/40 to-white"
      data-testid="convo-page"
    >
      <Navbar />
      <main className="flex-1 py-12 md:py-16 px-6">
        <div className="container mx-auto max-w-6xl">
          {/* Header */}
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-white/70 backdrop-blur border border-babyblue-200 text-primary px-4 py-1.5 rounded-full text-sm font-medium mb-5 shadow-sm">
              <MessagesSquare className="w-4 h-4" /> Germanatic Convos
            </div>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-babyblue-900 mb-3 tracking-tight">
              Gesprächs-Kickstarter
            </h1>
            <p className="text-babyblue-600 text-lg mb-4">Conversation Kickstarters</p>

            {/* Humans for humans pill */}
            <div className="mb-6">
              <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold">
                <Sparkles className="w-3.5 h-3.5" />
                Content made by humans, for humans.
              </div>
            </div>

            {/* Giant counter */}
            <div className="relative inline-block mb-4">
              <div className="font-heading text-7xl md:text-9xl font-extrabold bg-gradient-to-br from-primary via-babyblue-500 to-babyblue-700 bg-clip-text text-transparent tracking-tight leading-none">
                {totalReady}+
              </div>
              <Sparkles className="absolute -top-2 -right-6 w-8 h-8 text-primary animate-pulse" />
            </div>

            <div className="max-w-2xl mx-auto mt-4" data-testid="convo-intro">
              <p className="font-heading text-xl md:text-2xl font-bold text-babyblue-900 mb-3" data-testid="convo-intro-tagline">
                Lerne richtiges Deutsch und keinen Bullshit
              </p>
              <p className="text-babyblue-700">
                Use the following conversation kickstarters to have a conversation with your
                partner or record yourself answering the questions.
              </p>
              <p className="text-babyblue-700 mt-2 font-medium">
                Choose your level and a topic of your choice.
              </p>
            </div>

            {/* Stats strip */}
            <div className="flex flex-wrap justify-center gap-3 mt-8">
              <div className="bg-white border border-babyblue-200 rounded-full px-5 py-2 flex items-center gap-2 shadow-sm" data-testid="convo-stats-topics">
                <Sparkles className="w-4 h-4 text-primary" />
                <span className="font-bold text-babyblue-900">{totalReady}</span>
                <span className="text-babyblue-600 text-sm">Themen / topics</span>
              </div>
            </div>
          </div>

          {/* Search */}
          <div className="relative max-w-xl mx-auto mb-8">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-babyblue-400" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Thema suchen / Search topic..."
              className="w-full pl-12 pr-4 py-3.5 rounded-full border border-babyblue-200 bg-white text-babyblue-900 placeholder:text-babyblue-400 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm transition-all"
              data-testid="convo-search"
            />
          </div>

          {/* Level filter */}
          <div className="flex flex-wrap justify-center items-center gap-2 mb-6" data-testid="convo-level-filter">
            <span className="text-sm font-medium text-babyblue-700 mr-1">Level:</span>
            <button
              onClick={() => setLevel(null)}
              className={`px-4 py-1.5 rounded-full text-sm font-semibold border transition-colors ${
                !level ? 'bg-primary text-white border-primary' : 'bg-white text-babyblue-700 border-babyblue-200 hover:border-primary hover:text-primary'
              }`}
              data-testid="convo-level-all"
            >
              Alle / All
            </button>
            {LEVELS.map((lv) => (
              <button
                key={lv}
                onClick={() => setLevel(level === lv ? null : lv)}
                disabled={LEVEL_COUNTS[lv] === 0}
                className={`px-4 py-1.5 rounded-full text-sm font-semibold border transition-colors ${
                  level === lv
                    ? 'bg-primary text-white border-primary'
                    : LEVEL_COUNTS[lv] === 0
                    ? 'bg-babyblue-50 text-babyblue-300 border-babyblue-100 cursor-not-allowed'
                    : 'bg-white text-babyblue-700 border-babyblue-200 hover:border-primary hover:text-primary'
                }`}
                data-testid={`convo-level-${lv}`}
              >
                {lv} <span className="opacity-70 font-normal">({LEVEL_COUNTS[lv]})</span>
              </button>
            ))}
          </div>

          {!searchResults && (
            /* Alphabet nav */
            <div className="flex flex-wrap justify-center gap-1.5 mb-8">
              {ALPHABET.map((l) => {
                const count = CONVERSATIONS[l]?.length || 0;
                const active = activeLetter === l;
                return (
                  <button
                    key={l}
                    onClick={() => setActiveLetter(l)}
                    disabled={count === 0}
                    className={`w-10 h-10 rounded-xl font-heading font-bold text-sm transition-all ${
                      active
                        ? 'bg-primary text-white shadow-md scale-110'
                        : count === 0
                        ? 'bg-babyblue-50 text-babyblue-300 cursor-not-allowed'
                        : 'bg-white border border-babyblue-200 text-babyblue-700 hover:border-primary hover:text-primary hover:-translate-y-0.5 shadow-sm'
                    }`}
                    data-testid={`convo-letter-${l}`}
                  >
                    {l}
                  </button>
                );
              })}
            </div>
          )}

          {/* Section header */}
          <div className="flex items-baseline justify-between mb-4 px-1">
            <h2 className="font-heading text-2xl font-bold text-babyblue-900" data-testid="convo-section-title">
              {searchResults
                ? `${searchResults.length} ${searchResults.length === 1 ? 'Ergebnis' : 'Ergebnisse'}${search.trim() ? ` für „${search}"` : ''}${level ? ` · Level ${level}` : ''}`
                : `${activeLetter} — ${topics.length} ${topics.length === 1 ? 'Thema' : 'Themen'}`}
            </h2>
            {!searchResults && (
              <span className="text-xs text-babyblue-500 hidden md:block">
                Hover über eine Karte für eine Vorschau · Hover a card for a preview
              </span>
            )}
          </div>

          {/* Topic grid */}
          {displayed.length === 0 ? (
            <div className="bg-white rounded-2xl border border-babyblue-200 p-10 text-center text-babyblue-500">
              Keine Themen gefunden. / No topics found.
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {displayed.map((t, i) => {
                const Icon = iconFor(t.title);
                const hasQs = t.questions && t.questions.length > 0;
                return (
                  <button
                    key={`${t.letter}-${i}`}
                    onClick={() => setSelectedTopic(t)}
                    className="group relative text-left bg-white border border-babyblue-200 rounded-2xl p-4 hover:border-primary/50 hover:shadow-lg hover:-translate-y-0.5 transition-all overflow-hidden"
                    data-testid={`convo-topic-${t.title}`}
                  >
                    {/* Decorative letter watermark */}
                    <span
                      className="absolute -bottom-3 -right-2 font-heading text-6xl font-extrabold text-babyblue-50 group-hover:text-babyblue-100 transition-colors select-none pointer-events-none"
                      aria-hidden="true"
                    >
                      {t.letter}
                    </span>

                    <div className="relative flex items-start gap-3">
                      <div
                        className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${
                          hasQs
                            ? 'bg-gradient-to-br from-babyblue-100 to-babyblue-200 text-primary'
                            : 'bg-babyblue-50 text-babyblue-400'
                        }`}
                      >
                        <Icon className="w-5 h-5" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="font-heading font-semibold text-babyblue-900 truncate group-hover:text-primary transition-colors">
                          {t.title}
                        </div>
                        <div className="text-xs mt-0.5 flex items-center gap-1.5">
                          {hasQs ? (
                            <>
                              <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                              <span className="text-primary font-medium">
                                {t.questions.length} Fragen
                              </span>
                            </>
                          ) : (
                            <span className="text-babyblue-400">Freies Thema · Free-form</span>
                          )}
                        </div>
                      </div>
                      <ChevronRight className="w-4 h-4 text-babyblue-300 group-hover:text-primary group-hover:translate-x-0.5 transition-all flex-shrink-0" />
                    </div>

                    {/* Hover preview */}
                    {hasQs && (
                      <div className="relative grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-300 ease-out">
                        <div className="overflow-hidden">
                          <div className="border-t border-babyblue-100 mt-3 pt-3 space-y-1.5">
                            {t.questions.slice(0, 2).map((q, qi) => (
                              <div
                                key={qi}
                                className="flex gap-2 text-xs text-babyblue-700 leading-snug"
                              >
                                <span className="text-primary flex-shrink-0">›</span>
                                <span className="line-clamp-2">{q}</span>
                              </div>
                            ))}
                            {t.questions.length > 2 && (
                              <div className="text-xs text-primary font-medium pt-1">
                                + {t.questions.length - 2} weitere Fragen →
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ConversationsPage;
